export default "__VITE_ASSET__Bw1R8gkb__"